import GAListener from './GAListener';
import withGAEvent from './withGAEvent';

export { withGAEvent };
export default GAListener;